module.exports = __webpack_public_path__ + "media/logos/Boston Properties 1-4e6bc194.svg";